export default __webpack_public_path__ + "static/media/logo-ontest-branco.aefc210d.png";